import {
    loginRequest,
    sendEmailPasswordRequest,
    resetPasswordRequest,
    logoutRequest,
} from '@/services/api/auth/AuthService'
import axios from 'axios'

/**
 * @description
 * Call Login request and store user data if backend response is successed
 *
 * @param {Object} commit
 * @param {Promise} server response of request
 * @return
 */
const loginRequestAction = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        commit('authRequest')
        loginRequest(params)
            .then(response => {
                response.data.remember_me = params.remember_me ? params.rut : ''
                loginActions({ commit }, response)
                resolve(response)
            })
            .catch(err => {
                commit('authError', err)
                reject(err)
            })
    })
}

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return void
 */
const loginActions = ({ commit }, response) => {
    localStorage.setItem('user', JSON.stringify(response.data.user))
    localStorage.setItem(
        'user-token',
        response.data.token_type + ' ' + response.data.access_token
    )
    localStorage.setItem('remember-me', response.data.remember_me)
    // Here set the header of your ajax library to the token value.
    axios.defaults.headers.common['Authorization'] =
        response.data.token_type + ' ' + response.data.access_token
    commit('authSuccess', response.data.access_token)
}

/**
 * @description
 * Call logout request and delete user data if backend response is successed
 *
 * @param {Object} commit
 * @param {Promise} server response of request
 * @return
 */
const logoutRequestAction = ({ commit }) => {
    return new Promise((resolve, reject) => {
        logoutRequest()
            .then(response => {
                logoutActions({ commit })
                resolve(response)
            })
            .catch(err => {
                logoutActions({ commit })
                reject(err)
            })
    })
}

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return void
 */
const logoutActions = ({ commit }) => {
    commit('authLogout')
    localStorage.removeItem('user')
    localStorage.removeItem('user-token')
    delete axios.defaults.headers.common['Authorization']
}

/**
 * @description
 * Call send email reset password request
 *
 * @param {Object} commit
 * @param {Promise} server response of request
 * @return
 */
const sendEmailPasswordRequestAction = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        sendEmailPasswordRequest(params)
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                commit('authError', err)
                reject(err)
            })
    })
}

/**
 * @description
 * Call password reset request
 *
 * @param {Object} commit
 * @param {Promise} server response of request
 * @return
 */
const resetPasswordRequestAction = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        if (!params.token) {
            let url = window.location.href
            let token = url.split('/').pop() // get token of URL
            params.token = token
        }
        commit('authRequest')
        resetPasswordRequest(params)
            .then(response => {
                loginActions({ commit }, response)
                resolve(response)
            })
            .catch(err => {
                commit('authError', err)
                reject(err)
            })
    })
}

export default {
    loginRequestAction,
    logoutRequestAction,
    logoutActions,
    sendEmailPasswordRequestAction,
    resetPasswordRequestAction,
}
